import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpEvent,
  HttpRequest,
  HttpHeaders
} from "@angular/common/http";
import { Observable } from "rxjs";
import { Patients } from "app/models";

const uploadHeaders = {
  headers: new HttpHeaders({
    "upload": "multipart/form-data"
  })
};

@Injectable()
export class UploadFileService {
  constructor(private http: HttpClient) {}

  pushFileToStorage(file: File, patient: Patients, name :string): Observable<HttpEvent<{}>> {
    const formdata: FormData = new FormData();
    formdata.append("file", file, name );
    formdata.append("chemin", "C:/Users/PC/Documents/mas/HMO_neprosystem/nephrosystem/nephro-system-application/dossier_upload" );
    const req = new HttpRequest("POST", "doc/upload/post", formdata, {headers: uploadHeaders.headers
    });

    return this.http.request(req);
  }


  getFiles(): Observable<string[]> {
    return this.http.get<string[]>("api/upload/getallfiles");
  }

  getAll(): Observable<any> {
    return this.http.get("api/upload/all");
  }

  get(nomfichier:string): Observable<any> {
    return this.http.get("doc/upload/get",{headers:new HttpHeaders({
      "chemin": "C:/Users/PC/Documents/mas/HMO_neprosystem/nephrosystem/nephro-system-application/dossier_upload",
      "nom": nomfichier
    })
  });
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/uploadFile.service.ts